import { connect } from 'react-redux';
import { TApplicationState } from '../../types/redux';
import { Header, IHeaderProps } from '../../components/Header';
import { getNewbuildingDisplayName } from '../../selectors/newbuilding';

type THeaderStateProps = Pick<IHeaderProps, 'name'>;

export function mapStateToProps(state: TApplicationState): THeaderStateProps {
  return {
    name: getNewbuildingDisplayName(state),
  };
}

export const HeaderContainer = connect(mapStateToProps)(Header);
